<template>
  <div class="col-lg-6" >
    <div class="box-person">
      <div class="box-person-img">
        <ImageWrapper :file="contact.idPicture" :key="contact.idPicture"></ImageWrapper>
      </div>
      <div class="box-person-content">
        <span class="box-person-name">{{contact.name}}</span>
        <span class="box-person-position">{{contact.role}}</span>
        <a class="link-icon" v-if="contact.email" :href="`mailto:${contact.email}`"><i class="icon-mail-1"></i> <span>{{contact.email}}</span></a>
        <a class="link-icon" v-if="contact.phone"><i class="icon-phone"></i> <span>{{contact.phone}}</span></a>
        <a class="link-icon" v-if="contact.linkedIn" :href="`https://www.linkedin.com/in/${contact.linkedIn}`" target="_blank"><i class="icon-person"></i> <span>LinkedIn profile</span></a>
<!--        <span class="span-icon" v-if="contact.country"><i class="icon-net"></i> {{contact.country}}</span>-->
        <span class="span-icon" v-if="contact._embedded && contact._embedded.Country.value"><i class="icon-net"></i> {{contact._embedded.Country.value}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import ImageWrapper from "@/components/general/ImageWrapper";

export default {
name: "ContactInfo",
  components: {ImageWrapper},
  props: ['contact'],
}
</script>

<style scoped>

</style>
